import * as parse from "./parse";
import * as next from "./next";

export default { ...parse, ...next };
